import { normalizeSocialConnectionId } from './connection-id'

export function planInitialConnectionHydration({
  workspaceAvailable,
  alreadyHydrated,
  requestedConnectionId,
  activeConnectionId,
}: {
  workspaceAvailable: boolean
  alreadyHydrated: boolean
  requestedConnectionId: string | null | undefined
  activeConnectionId: string | null
}): {
  markHydrated: boolean
  connectionToOpen: string | null
} {
  if (!workspaceAvailable || alreadyHydrated) {
    return {
      markHydrated: false,
      connectionToOpen: null,
    }
  }
  const normalizedRequest = normalizeSocialConnectionId(requestedConnectionId)
  const normalizedActive = normalizeSocialConnectionId(activeConnectionId)
  return {
    markHydrated: true,
    connectionToOpen:
      normalizedRequest
      && normalizedRequest !== normalizedActive
        ? normalizedRequest
        : null,
  }
}
